import { Provider } from "@angular/core";
import { API_BASE_URL } from "../services/api-services";
import { AppConfigService } from "../services/app-config.service";

export const ApiBaseUrlProvider: Provider = { 
  provide: API_BASE_URL, 
  useFactory: (appConfigService: AppConfigService) => appConfigService.getConfig().apiUrl, 
  deps: [AppConfigService] 
};